import s2 from './styles.module.scss';
import { Box } from '@chakra-ui/react';
import React, { useRef, useState } from 'react';
import useClickOutside from '@/hooks/useHoverOutside';
import IcUser from '@/modules/AlphaPWA/Profiles/TradeKey/components/profileHeaderUserInfo/Icons/IcUser';
import { IcMenuAction } from '@/modules/AlphaPWA/Profiles/TradeKey/components/svg/ic-menu-action';
import IcFrens from '@/modules/AlphaPWA/Profiles/TradeKey/components/profileHeaderUserInfo/Icons/IcFrens';
import IcComumity from '@/modules/AlphaPWA/Profiles/TradeKey/components/profileHeaderUserInfo/Icons/IcComumity';
import router from 'next/router';

interface ITabTileSocial {
  view: 'CIRCLE' | 'SQUARE';
  address: string;
}
export default function MenuHoldDetail({ view, address }: ITabTileSocial) {
  const [isShow, setIsShow] = useState(false);
  const refContent = useRef<HTMLDivElement>(null);

  useClickOutside(refContent, () => setIsShow(false));

  return (
    <Box ref={refContent} className={`${s2.user_metadata}`}>
      <div
        className={s2.user_metadata_action}
        onClick={() => setIsShow(pre => !pre)}
      >
        <IcMenuAction />
      </div>
      {isShow && (
        <div className={s2.user_metadata_topup}>
          <div
            onClick={e => {
              e.stopPropagation();
              router.push(`/alpha/profile/${address}`);
            }}
            className={`${s2.user_metadata_topup_item}`}
          >
            <div className={s2.left}>
              <IcUser />
              {`View Creator Profile`}
            </div>
          </div>
          {view !== 'CIRCLE' && (
            <div
              onClick={e => {
                e.stopPropagation();
                router.push(`/alpha/profile/${address}?view=circle`);
              }}
              className={`${s2.user_metadata_topup_item}`}
            >
              <div className={s2.left}>
                <IcFrens />
                {`View Circle Profile`}
              </div>
            </div>
          )}
          {view !== 'SQUARE' && (
            <div
              onClick={e => {
                e.stopPropagation();
                router.push(`/alpha/profile/${address}?view=community`);
              }}
              className={`${s2.user_metadata_topup_item}`}
            >
              <div className={s2.left}>
                <IcComumity />
                {`View Community Profile`}
              </div>
            </div>
          )}
        </div>
      )}
    </Box>
  );
}
